<template>
  <div class="Sidebar">
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'

export default defineNuxtComponent({
})
</script>

<style scoped>
.Sidebar {
  width: 328px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
